module.exports = __webpack_public_path__ + "media/palenque/small_mayan-ec8bbc69.jpg";